import { Badge, BadgeProps, useMantineTheme } from '@mantine/core'
import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'
import classes from './StatusBadge.module.css'

type StatusBadgeProps = BadgeProps &
  Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
    icon?: ReactNode
    borderColor?: string
    component?: 'button'
  }

export const StatusBadge = ({
  children,
  icon,
  color = 'brand',
  variant = 'light',
  size = 'md',
  radius = 'xl',
  borderColor,
  className,
  style,
  component,
  ...props
}: StatusBadgeProps) => {
  const theme = useMantineTheme()
  const colorKey = typeof color === 'string' ? color : 'brand'
  const resolvedBorderColor =
    borderColor ?? theme.colors[colorKey]?.[6] ?? theme.colors.gray[6]

  const badgeStyle = {
    '--status-badge-border-color': resolvedBorderColor,
    ...style,
  } as CSSProperties & Record<'--status-badge-border-color', string>

  return (
    <Badge
      className={[
        classes.badge,
        component === 'button' && classes.button,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      color={color}
      component={component}
      leftSection={icon}
      radius={radius}
      size={size}
      style={badgeStyle}
      variant={variant}
      {...props}
    >
      {children}
    </Badge>
  )
}
